import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import StudentModals from "../studentModals";
import StudentSidebar from "./studentSidebar";
import StudentBreadcrumb from "./studentBreadcrumb";
import { getUser } from "../../../network/auth/Auth";
import UserService from "../../../network/services/UserService";

const StudentResult = () => {

  interface ExamData {
    id: any;
    name: any;
    start_date: any;
    end_date: any;

  }
  const [exams, setExams] = useState<ExamData[]>([]);

  const fetchData = async (student_id: any, company_id: any) => {
    UserService.getExamCourse(student_id, company_id, (response: any) => {
      if (response?.data && response?.success) {
        console.log(response.data);
        setExams(response.data)


      }
    });
  };

  const fetchDataUser = async (student_id: any) => {
    UserService.getAdmissionCourse(student_id, (response: any) => {
      if (response?.data && response?.success) {
        console.log(response.dta);
        if (response?.data[0]?.courses[0]) {
          fetchData(student_id, response?.data[0]?.courses[0]?.id);
        }


      }
    });
  };

  const navigation = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (location?.state) {
      fetchDataUser(location?.state?.student?.id)


    }
  }, []);


  const navigeStudentDetails = (student: any) => {
    navigation(routes.studentDetail, { state: { student: student } })
  }

  const navigeStudentTimeline = (student: any) => {
    navigation(routes.studentTimeTable, { state: { student: student } })
  }
  const navigeStudentLeaves = (student: any) => {
    navigation(routes.studentLeaves, { state: { student: student } })
  }

  const navigeStudentExam = (student: any) => {
    navigation(routes.studentResult, { state: { student: student } })
  }

  const routes = all_routes;

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            {/* Page Header */}
            <StudentBreadcrumb />
            {/* /Page Header */}
          </div>
          <div className="row">
            {/* Student Information */}
            <StudentSidebar student={location?.state?.student} />
            {/* /Student Information */}
            <div className="col-xxl-9 col-xl-8">
              <div className="row">
                <div className="col-md-12">
                  {/* List */}
                  <ul className="nav nav-tabs nav-tabs-bottom mb-4">
                    <li>
                      <a onClick={() => navigeStudentDetails(location?.state?.student)} className="nav-link active">
                        <i className="ti ti-school me-2" />
                        Student Details
                      </a>
                    </li>
                    <li>
                      <a onClick={() => navigeStudentTimeline(location?.state?.student)} className="nav-link active">
                        <i className="ti ti-table-options me-2" />
                        Time Table
                      </a>
                    </li>
                    <li>
                      <a onClick={() => navigeStudentLeaves(location?.state?.student)} className="nav-link active">
                        <i className="ti ti-calendar-due me-2" />
                        Attendance
                      </a>
                    </li>

                    <li>
                      <a onClick={() => navigeStudentExam(location?.state?.student)} className="nav-link active">
                        <i className="ti ti-bookmark-edit me-2" />
                        Exam &amp; Results
                      </a>
                    </li>
                  </ul>
                  {/* /List */}
                  <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
                      <h4 className="mb-3">Exams &amp; Results</h4>
                      <div className="d-flex align-items-center flex-wrap">
                        <div className="dropdown mb-3 me-2">
                          <Link
                            to="#"
                            className="btn btn-outline-light bg-white dropdown-toggle"
                            data-bs-toggle="dropdown"
                            data-bs-auto-close="outside"
                          >
                            <i className="ti ti-calendar-due me-2" />
                            Year : 2024 / 2025
                          </Link>
                          <ul className="dropdown-menu p-3">
                            <li>
                              <Link to="#" className="dropdown-item rounded-1">
                                Year : 2024 / 2025
                              </Link>
                            </li>
                            <li>
                              <Link to="#" className="dropdown-item rounded-1">
                                Year : 2023 / 2024
                              </Link>
                            </li>
                            <li>
                              <Link to="#" className="dropdown-item rounded-1">
                                Year : 2022 / 2023
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <div
                        className="accordions-items-seperate"
                        id="accordionExample"
                      >
                        {exams && exams?.map((item: any, index: any) => (
                          <div className="accordion-item " >
                            <h2 className="accordion-header">
                              <button
                                className="accordion-button"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`#collapseOne${index}`}
                                aria-expanded="true"
                                aria-controls={`collapseOne${index}`}
                              >
                                <span className="avatar avatar-sm bg-success me-2">
                                  <i className="ti ti-checks" />
                                </span>
                                {item?.name}({item?.start_date} - {item?.end_date})
                              </button>
                            </h2>
                            <div
                              id={`collapseOne${index}`}
                              className="accordion-collapse collapse "
                              data-bs-parent={`#accordionExample${index}`}
                            >
                              <div className="accordion-body">
                                {/* Exam Result List */}
                                <div className="table-responsive">
                                  <table className="table">
                                    <thead className="thead-light">
                                      <tr>
                                        <th>Subject</th>
                                        <th>Max Marks</th>
                                        <th>Min Marks</th>
                                        <th>Marks Obtained</th>
                                        <th className="text-end">Result</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {item?.result_lines && item?.result_lines?.map((item2: any) => (
                                        <tr>
                                          <td>{item2.subject}</td>
                                          <td>{item2.total_marks}</td>
                                          <td>{item2.min_marks}</td>
                                          <td>{item2.marks}</td>
                                          <td className="text-end">
                                            {item2.status == "pass" ?
                                              (<span className="badge badge-soft-success d-inline-flex align-items-center">
                                                <i className="ti ti-circle-filled fs-5 me-1" />
                                                {item2.status}
                                              </span>) : (
                                                <span className="badge badge-soft-danger d-inline-flex align-items-center">
                                                  <i className="ti ti-circle-filled fs-5 me-1" />
                                                  {item2.status}
                                                </span>
                                              )
                                            }
                                          </td>
                                        </tr>
                                      ))}


                                      <tr>
                                        <td className="bg-dark text-white">
                                          Rank : __
                                        </td>
                                        <td className="bg-dark text-white">
                                          Total : {(item?.total_marks / item?.percentage * 100)}
                                        </td>
                                        <td
                                          className="bg-dark text-white"
                                          colSpan={2}
                                        >
                                          Marks Obtained : {item?.total_marks}
                                        </td>
                                        <td className="bg-dark text-white text-end">
                                          <div className="d-flex align-items-center justify-content-end">
                                            <span className="me-2">
                                              Percentage : {item?.percentage}
                                            </span>
                                            <h6 className="fw-normal text-white">
                                              Result :{" "}
                                              {item.status == "pass" ?
                                                (<span className="text-success">
                                                  {item.status}
                                                </span>) : (
                                                  <span className="text-danger">
                                                    {item.status}
                                                  </span>
                                                )
                                              }

                                            </h6>
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                {/* /Exam Resul List */}
                              </div>
                            </div>
                          </div>))}


                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      <StudentModals />
    </>
  );
};

export default StudentResult;
